'use client';

import { useState, useEffect } from 'react';
import StickyNavigation from '@/components/common/StickyNavigation';
import WhatsAppFloatingButton from '@/components/common/WhatsAppFloatingButton';
import SectionAnchorManager from '@/components/common/SectionAnchorManager';
import ConversionTracker from '@/components/common/ConversionTracker';
import HeroSection from './HeroSection';
import CompanyIntroduction from './CompanyIntroduction';
import MissionVisionValues from './MissionVisionValues';
import ServicesShowcase from './ServicesShowcase';
import ProjectsPortfolio from './ProjectsPortfolio';
import CompetitiveAdvantages from './CompetitiveAdvantages';
import ContactSection from './ContactSection';
import FAQSection from './FAQSection';
import FooterSection from './FooterSection';

const LandingPageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const sections = [
    { id: 'services', offset: 80 },
    { id: 'projects', offset: 80 },
    { id: 'about', offset: 80 },
    { id: 'contact', offset: 80 }
  ];

  const trackingSections = ['hero', 'about', 'services', 'projects', 'contact'];

  const handleRequestQuote = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const offset = 80;
      const elementPosition = contactSection.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleScheduleConsultation = () => {
    const whatsappPhone = '+250788123456';
    const message = 'Hello, I would like to schedule a consultation for my EPC project.';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappPhone.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  const handleWhatsAppClick = () => {
    const whatsappPhone = '+250788123456';
    const message = 'Hello, I would like to inquire about your EPC services.';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappPhone.replace(/[^0-9]/g, '')}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  const handleEngagementUpdate = (engagement: any[]) => {
    if (!isHydrated) return;
    console.log('Engagement data:', engagement);
  };

  return (
    <>
      <StickyNavigation 
        isOpen={isNavOpen} 
        onToggle={() => setIsNavOpen(!isNavOpen)} 
      />
      
      <SectionAnchorManager sections={sections} />
      
      <ConversionTracker 
        sections={trackingSections}
        onEngagementUpdate={handleEngagementUpdate}
      />

      <main className="min-h-screen">
        <HeroSection 
          onRequestQuote={handleRequestQuote}
          onScheduleConsultation={handleScheduleConsultation}
        />
        
        <CompanyIntroduction />
        
        <MissionVisionValues />
        
        <ServicesShowcase />
        
        <ProjectsPortfolio />
        
        <CompetitiveAdvantages />
        
        <ContactSection onWhatsAppClick={handleWhatsAppClick} />
        
        <FAQSection />
        
        <FooterSection />
      </main>

      <WhatsAppFloatingButton 
        phoneNumber="+250 796 849 065"
        defaultMessage="Hello, I would like to inquire about your EPC services."
        showAfterScroll={300}
      />
    </>
  );
};

export default LandingPageInteractive;